export default {
  install(Vue, runtimeConfigurationOptions) {
    const mediasUrl = runtimeConfigurationOptions.mediasUrl;
    document.getElementById('favicon-variable').setAttribute('href', mediasUrl.concat('favicons/favicon.ico'));
  },
};
